import React, { useEffect } from "react";
import { HomePageCarSearch, CarTrackingProvider } from "@capone/portal";
import { HomePageCarSearch as CorpHomePageCarSearch } from "@capone-corporate/portal";
import { isCorpTenant } from "@capone/common";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { parseCarEntryType } from "redmond/build";
import { trackEvent } from "../../api/v1/trackEvent";
import { config } from "../../api/config";

export const CarSearch = ({ className }: { className?: string }) => {
  const location = useLocation();

  useEffect(() => {
    const params = queryString.parse(location.search);
    const entryType = parseCarEntryType(params.entryType as string);
    const entryTypesAll = entryType ? [entryType] : undefined;

    trackEvent({
      eventName: "viewed_cars_search",
      properties: {
        entry_type: entryType,
        entry_types_all: entryTypesAll,
      },
    });
  }, [location.search]);

  if (isCorpTenant(config.TENANT)) {
    return <CorpHomePageCarSearch className={className} />;
  }
  return (
    <CarTrackingProvider>
      <HomePageCarSearch className={className} />
    </CarTrackingProvider>
  );
};
